module.exports = __webpack_public_path__ + "img/experimentNo.6fa182f3.svg";